import { EMAIL_SLIDE, NAME_SLIDE, PAUSE_SLIDE, PLAN_GRAPH_SLIDE, PLAN_LOADER_SLIDE, PROFILE_SLIDE, QUESTION_ANSWER_SLIDE_COMPONENT, PRESALE_SLIDE, START_SLIDE } from '../quiz-component-types';

const QUIZ_SLIDES_V38 = [
    {
        id: 900,
        component: START_SLIDE,
        isNotIndexing: true
    },
    {
        id: 9100,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Thickness',
            question: 'At dinner someone says “that reminds me of a story…” How often is that you?',
            answers: [
                {
                    text: 'Rarely. I’m the one asking questions.',
                    icon: 'ear',
                    id: 1
                },
                {
                    text: 'Now and then, if it’s a good one.',
                    icon: 'slightly-smiling-face',
                    id: 2
                },
                {
                    text: 'Often. I have a story for most topics.',
                    icon: 'speaking-head',
                    id: 3
                },
                {
                    text: 'Always. People stay for dessert just for my stories.',
                    icon: 'shortcake',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9101,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Thickness',
            question: 'How many “past lives” have you had? Think big fresh starts: a new city, a new job, a new love.',
            answers: [
                {
                    text: 'One life, and I love it',
                    icon: 'house-with-garden',
                    id: 1
                },
                {
                    text: 'Two or three',
                    icon: 'victory-hand',
                    id: 2
                },
                {
                    text: 'Four or five',
                    icon: 'hand-with-fingers-splayed',
                    id: 3
                },
                {
                    text: 'I’ve lost count',
                    icon: 'infinity',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9102,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Thickness',
            question: 'How many people could tell a story about you that you’d rather they didn’t?',
            answers: [
                {
                    text: 'Nobody. I’m an open book.',
                    icon: 'open-book',
                    id: 1
                },
                {
                    text: 'One or two, sworn to secrecy',
                    icon: 'zipper-mouth-face',
                    id: 2
                },
                {
                    text: 'A whole group chat',
                    icon: 'speech-balloon',
                    id: 3
                },
                {
                    text: 'Half the town',
                    icon: 'megaphone',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9103,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v25',
            heading: 'The Thickness: done.',
            nextIcon: 'performing-arts',
            nextTitle: 'What genre is your life?',
            fact: 'With Boundly you don’t have to write. You talk, and your stories become pages.',
            completedParts: 1
        }
    },
    {
        id: 9104,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Genre',
            question: 'A free Saturday, no plans. By evening I’ve…',
            answers: [
                {
                    text: '…driven somewhere I’d never been',
                    icon: 'compass',
                    id: 1
                },
                {
                    text: '…ended up on a date, or at least flirting',
                    icon: 'clinking-glasses',
                    id: 2
                },
                {
                    text: '…finished a project nobody asked me to start',
                    icon: 'chart-increasing',
                    id: 3
                },
                {
                    text: '…cooked for twelve people who “just dropped by”',
                    icon: 'pot-of-food',
                    id: 4
                },
                {
                    text: '…collected a new disaster story',
                    icon: 'see-no-evil-monkey',
                    id: 5
                },
                {
                    text: '…found out a secret I really shouldn’t know',
                    icon: 'eyes',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9105,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Genre',
            question: 'What do friends call you for?',
            answers: [
                {
                    text: 'Where to go next',
                    icon: 'world-map',
                    id: 1
                },
                {
                    text: 'Love advice, I’ve seen it all',
                    icon: 'heart-with-arrow',
                    id: 2
                },
                {
                    text: 'Money, work, and negotiating',
                    icon: 'briefcase',
                    id: 3
                },
                {
                    text: 'Holding everyone together',
                    icon: 'hugging-face',
                    id: 4
                },
                {
                    text: 'Cheering them up after a terrible day',
                    icon: 'laughing-tears',
                    id: 5
                },
                {
                    text: 'The gossip, they know I keep secrets',
                    icon: 'shushing-face',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9106,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Genre',
            question: 'What do people say about you most?',
            answers: [
                {
                    text: '“You did WHAT?”',
                    icon: 'face-with-open-mouth',
                    id: 1
                },
                {
                    text: '“She’s trouble. The good kind.”',
                    icon: 'smirking-face',
                    id: 2
                },
                {
                    text: '“Of course she pulled it off.”',
                    icon: 'crown',
                    id: 3
                },
                {
                    text: '“She’s the glue of the group.”',
                    icon: 'thread',
                    id: 4
                },
                {
                    text: '“Only you could make this funny.”',
                    icon: 'grinning-face-with-sweat',
                    id: 5
                },
                {
                    text: '“Nobody knows what she’s really thinking.”',
                    icon: 'sunglasses',
                    id: 6
                }
            ]
        }
    },
    {
        id: 9107,
        component: PAUSE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        },
        props: {
            variant: 'v25',
            heading: 'The Genre: done.',
            nextIcon: 'hot-pepper',
            nextTitle: 'How hot is it?',
            fact: 'Every question follows your answers. No templates, no blank page.',
            completedParts: 2
        }
    },
    {
        id: 9108,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Heat',
            question: 'Your best friend is giving a toast at your birthday party. What do you beg her not to mention?',
            answers: [
                {
                    text: 'Nothing. She can tell it all.',
                    icon: 'halo',
                    id: 1
                },
                {
                    text: 'The work trip. Just the work trip.',
                    icon: 'luggage',
                    id: 2
                },
                {
                    text: 'Anything from that one summer',
                    icon: 'sun',
                    id: 3
                },
                {
                    text: 'She signed an NDA years ago',
                    icon: 'memo',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9109,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Heat',
            question: 'Your perfect evening:',
            answers: [
                {
                    text: 'A book, a blanket, an early night',
                    icon: 'couch-and-lamp',
                    id: 1
                },
                {
                    text: 'A long dinner with a few close friends',
                    icon: 'wine-glass',
                    id: 2
                },
                {
                    text: 'Cocktails that turn into dancing',
                    icon: 'cocktail-glass',
                    id: 3
                },
                {
                    text: 'I don’t plan evenings. They plan me.',
                    icon: 'crescent-moon',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9110,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Heat',
            question: 'One word your exes would use for you:',
            answers: [
                {
                    text: 'Exes? I married my first love.',
                    icon: 'ring',
                    id: 1
                },
                {
                    text: 'Kind',
                    icon: 'smiling-face-with-smiling-eyes',
                    id: 2
                },
                {
                    text: 'Unforgettable',
                    icon: 'sparkles',
                    id: 3
                },
                {
                    text: 'Dangerous',
                    icon: 'smiling-face-with-horns',
                    id: 4
                }
            ]
        }
    },
    {
        id: 9111,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Title',
            question: 'Every author names her own book. Pick the one that sounds like you.',
            answersByArchetype: {
                adventure: [
                    { text: 'Where the Road Took Me', icon: 'motorway', id: 1 },
                    { text: 'No Map, No Problem', icon: 'compass', id: 2 },
                    { text: 'Pack Light, They Said', icon: 'backpack', id: 3 }
                ],
                loveStory: [
                    { text: 'The Love That Stayed', icon: 'love-letter', id: 4 },
                    { text: 'Worth Every Heartbreak', icon: 'broken-heart', id: 5 },
                    { text: 'Things I Never Told My Mother', icon: 'rose', id: 6 }
                ],
                successStory: [
                    { text: 'Built From Scratch', icon: 'brick', id: 7 },
                    { text: 'She Wore Red to the Meeting', icon: 'high-heeled-shoe', id: 8 },
                    { text: 'Too Much, and Proud of It', icon: 'crown', id: 9 }
                ],
                familySaga: [
                    { text: 'All the Women Before Me', icon: 'women-holding-hands', id: 10 },
                    { text: 'The One Who Held It Together', icon: 'yarn', id: 11 },
                    { text: 'What We Don’t Say at Dinner', icon: 'shushing-face', id: 12 }
                ],
                comedy: [
                    { text: 'Somehow It All Worked Out', icon: 'four-leaf-clover', id: 13 },
                    { text: 'Bad Decisions, Great Stories', icon: 'roller-coaster', id: 14 },
                    { text: 'It Seemed Like a Good Idea at the Time', icon: 'woman-facepalming', id: 15 }
                ],
                mystery: [
                    { text: 'The Quiet One', icon: 'magnifying-glass', id: 16 },
                    { text: 'She Left Without Explaining', icon: 'candle', id: 17 },
                    { text: 'Burn After Reading', icon: 'fire', id: 18 }
                ]
            }
        }
    },
    {
        id: 9112,
        component: QUESTION_ANSWER_SLIDE_COMPONENT,
        props: {
            category: 'The Dedication',
            question: 'Who is “{title}” written for?',
            titleSourceId: 9111,
            answers: [
                {
                    text: 'For my mother',
                    icon: 'heart-hands',
                    id: 1
                },
                {
                    text: 'For my children',
                    icon: 'baby',
                    id: 2
                },
                {
                    text: 'For me. Finally.',
                    icon: 'butterfly',
                    id: 3
                },
                {
                    text: 'For everyone who said I couldn’t',
                    icon: 'flexed-biceps',
                    id: 4
                }
            ]
        }
    },
    {
        id: 944,
        component: PLAN_LOADER_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true,
        props: {
            steps: ['Measuring the thickness…', 'Shelving it by genre…', 'Checking the heat…', 'Designing your cover…']
        }
    },
    {
        id: 9114,
        component: NAME_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 945,
        component: EMAIL_SLIDE,
        isNotBackButton: true,
        isNotIndexing: true
    },
    {
        id: 9006,
        component: PROFILE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true
        }
    },
    {
        id: 946,
        component: PLAN_GRAPH_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true,
            label: 'Start chapter one'
        }
    },
    {
        id: 9120,
        component: PRESALE_SLIDE,
        isNotIndexing: true,
        continueButton: {
            isVisible: true,
            label: 'Get my plan'
        }
    }
];

export {
    QUIZ_SLIDES_V38
};
